import React, { createContext } from 'react'
import { TelemetryRootContextType } from './types'

/**
 * this function generates a default instrumentation root context
 * @return {React.Context} - the instrumentation root context
 */
export function createRootContext(): React.Context<TelemetryRootContextType> {
  return createContext({} as TelemetryRootContextType)
}

export default createRootContext()
